export default "__VITE_ASSET__1aFGhey5__"